module.exports = __webpack_public_path__ + "static/media/geologo.87ca3312.svg";